<template>
  <EmailEmailAddrSet />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
